<template>
    <div class="flex float-left vertical-center">
        <vs-button v-bind:id="'btn-row-edit-'+row_number" v-if="show" size="small" icon-pack="feather" icon="icon-edit" @click="editRecord"
                   color="success"
                   class="mr-2"></vs-button>
        <vs-button v-bind:id="'btn-row-detail-'+row_number" v-if="readShow" size="small" icon-pack="feather" icon="icon-eye" @click="readRecord"
                   color="primary"
                   class="mr-2"></vs-button>
        <vs-button v-bind:id="'btn-row-delete-'+row_number" size="small" icon-pack="feather" v-if="isDelete" icon="icon-trash" @click="deleteRecord"
                   color="danger"></vs-button>
    </div>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "ActionTableAgGridComponent",
        data() {
            return {
                isDelete: false,
                show:true,
                readShow:false,
                row_number: 0,
            }
        },
        methods: {
            deleteRecord() {
                this.$root.$emit("delete-from-ActionTableAgGridComponent", this.params.value)
            },
            editRecord() {
                this.$root.$emit("edit-from-ActionTableAgGridComponent", this.params.data)
            },
            readRecord() {
                this.$root.$emit("read-from-ActionTableAgGridComponent", this.params.data)
            },
            created() {

            }
        },
        created() {
            this.row_number = this.params.data.no
            this.isDelete = this.params.isDelete

            if (this.params.readShow) this.readShow = true

            const role = localStorage.getItem("userRole")
            const merchant = JSON.parse(localStorage.getItem("userInfo")).merchant

            if (!(role == 'root' || role == 'administrator' || role == 'aino_cc' || role == 'merchant_admin') ) {
                this.show=false
            }else{
                if ((merchant.id !== undefined && merchant.id !== this.params.value) &&  parseInt(this.params.data.depth) <= parseInt(merchant.depth)) this.show= false;
            }
        },
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
</style>